import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MainService } from 'src/app/main.service';

const DEFAULT_SUPPORT_EMAIL = 'soporte@inprovider.cl';

@Component({
  selector: 'app-pjud-unavailable-modal',
  templateUrl: './pjud-unavailable-modal.component.html',
  styleUrls: ['./pjud-unavailable-modal.component.scss'],
  standalone: false
})
export class PjudUnavailableModalComponent implements OnInit {
  @Input() title = 'Seguimiento PJUD';
  @Input() message: string;

  supportEmail = DEFAULT_SUPPORT_EMAIL;
  copied = false;
  loadingEmail = true;

  constructor(
    public activeModal: NgbActiveModal,
    private mainService: MainService
  ) {}

  ngOnInit() {
    this.mainService.getSupportContact().subscribe({
      next: (resp: any) => {
        const email = resp?.result?.email ?? resp?.email;
        if (email) {
          this.supportEmail = email;
        }
        this.loadingEmail = false;
      },
      error: () => {
        this.loadingEmail = false;
      }
    });
  }

  copyEmail() {
    const text = this.supportEmail;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => this.markCopied());
      return;
    }
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      this.markCopied();
    } finally {
      document.body.removeChild(textarea);
    }
  }

  private markCopied() {
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 2000);
  }
}
